import { render, staticRenderFns } from "./TextAnswer.vue?vue&type=template&id=09ff4590&"
import script from "./TextAnswer.vue?vue&type=script&lang=js&"
export * from "./TextAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports